(function () {

    'use strict';

    function pxSiteTree() {
        return {
            restrict: 'EA',
            scope: {
                me: '=',
                loading: '=',
                sites: '=',
                onFolderSelected: '&',
                onSiteSelected: '&'
            },
            templateUrl: 'app/components/settings/cloudStorage/selectSites/siteTree.template.html',
            link: function (scope) {

                scope.selectFolder = function (folder) {
                    let executeDefault = true;
                    if (scope.onFolderSelected) {
                        executeDefault = scope.onFolderSelected({ folder: folder });
                    }
                    if (executeDefault) {
                        folder.open = !folder.open;
                    }
                };

                scope.selectSite = function (site) {
                    let executeDefault = true;
                    if (scope.onSiteSelected) {
                        executeDefault = scope.onSiteSelected({ site: site });
                    }
                    if (executeDefault) {
                        //
                    }
                };

            }
        };
    }

    pxSiteTree.$inject = [];

    angular
        .module('printix-admin')
        .directive('pxSiteTree', pxSiteTree);

})();
